module.exports = __webpack_public_path__ + "10dfacaa23c044cd2fb2182b6f5a8b2d.svg";